<template>
<div id="whole" @wheel="handleScroll">

  <div id="intro" v-if="this.page == 1" @click="switchStatus">
    <div v-if="this.status==1"> <page-one></page-one></div>
    <div v-if="this.status==2"> <page-two></page-two></div>

  </div>

  <div v-if="this.page == 2"> <page-three> </page-three></div>




</div>
</template>

<script>
import 'animate.css';
import PageOne from "@/components/page1/page1";
import PageTwo from "@/components/page2/page2";
import PageThree from "@/components/page3/pageThree";
export default {
  name: "cardAvatar",
  components: {PageThree, PageTwo, PageOne},
  data(){
    return {
      page: 1,
      status: 1
    }
  },
  methods: {
    handleScroll(e) {
      if (e.deltaY > 0) {
        // 向下滚动...
        if(this.page < 2) {
          this.page++;
        }
      } else {
        // 向上滚动...
        if(this.page>1) {
          this.page--;
        }
      }
    },
    switchStatus(){
      if(this.status==1){
        this.status=2;
      }else{
        this.status=1;
      }
    }
  }
}
</script>

<style scoped>
span{
  color: aliceblue;
}

</style>